import Lenis from "lenis";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let instance: Scroll;

class Scroll {
  scroll!: Lenis;

  constructor() {
    if (instance) {
      throw new Error("You can only create one instance!");
    }
    instance = this;

    this.init();
  }

  init() {
    // Initializes smooth scrolling with Lenis and integrates it with GSAP's ScrollTrigger.
    // Function to set up smooth scrolling.
    // Initialize Lenis for smooth scroll effects. Lerp value controls the smoothness.
    const lenis = new Lenis({
      lerp: 0.25,
      // prevent: (node) => node.id === 'header-nav',
    });

    // function raf(time: number) {
    //   lenis.raf(time);
    //   requestAnimationFrame(raf);
    // }

    // requestAnimationFrame(raf);

    // Sync ScrollTrigger with Lenis' scroll updates.
    lenis.on('scroll', ScrollTrigger.update);

    // Ensure GSAP animations are in sync with Lenis' scroll frame updates.
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000); // Convert GSAP's time to milliseconds for Lenis.
    });

    // Turn off GSAP's default lag smoothing to avoid conflicts with Lenis.
    gsap.ticker.lagSmoothing(0);

    this.scroll = lenis;
  }

  disableScrolling() {
    this.scroll.stop();
  }

  enableScrolling() {
    this.scroll.start();
  }
}

const SmoothScroll = Object.freeze(new Scroll());
export default SmoothScroll;
